import type { TFormatView, TUnionType } from './models';

/**
 * Разбивает числа на тысячи (1000000.01 -> 1 000 000,01), приводя их к стандарту ru-RU
 * @param rawValue - Значение для форматирования
 * @param options - Опции для функции `toLocaleString`
 * @param formatView - Указывает форматирование для чисел меньше 10 000 (по умолчанию 'compactSmallNumbers')
 */
export const separateThousands = (
    rawValue: TUnionType,
    options: Intl.NumberFormatOptions = {
        maximumFractionDigits: 10,
    },
    formatView: TFormatView = 'compactSmallNumbers'
) => {
    const value = (rawValue ?? '')
        .toString()
        .replace(',', '.')
        .replace(/\u00a0/g, '');

    if (!value || Number.isNaN(Number(value))) return '';

    const numberValue = Number(value);

    if (formatView === 'compactSmallNumbers' && Math.abs(numberValue) < 10000) {
        return numberValue.toLocaleString('ru-RU', { ...options, useGrouping: false });
    }

    return numberValue.toLocaleString('ru-RU', options);
};
